import { html } from '@effectivastudio/lit-components';
import DateOption from '@effectivastudio/lit-components/components/date_option/element.js';
import OrganizeOption from '@effectivastudio/lit-components/components/organize_option/element.js';
import PollOption from '@effectivastudio/lit-components/components/poll_option/element.js';

OrganizeOption.config.icons.check = '';

PollOption.config = {
  icons: {
    check: '',
    minus: 'check:solid',
    plus: '',
  },
};

DateOption.config = {
  icons: {
    check: '',
    minus: 'check:solid',
    plus: '',
  },
};

OrganizeOption.prototype.renderLabel = function () {
  const percentageOn = this.amount && this.goal && this.readOnlyOn;
  const percentage = percentageOn
    ? Math.round((this.amount / this.goal) * 100)
    : null;

  return html`
    <ef-label>
      ${this.goal ? `${this.amount}/${this.goal}` : this.amount} &nbsp
      ${percentageOn ? `(${percentage}%)` : null}
    </ef-label>
  `;
};
